export const wholeSeriesPopupButtonConfig = [
    { id: 1, value: "no", style: "Secondarybutton me-2" },
    { id: 2, value: "yes", style: "primarybutton" },
  ];